(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["wizard"] && !Shopify.designMode) return;
  try {
    
(function init() {
  const wizard = document.querySelector(".js-wizard");
  if (!wizard) return;
  const wizardBody = wizard.querySelector(".js-wizard-body");
  const wizardNextButton = wizard.querySelector(".js-c-wizard-next");
  const wizardPrevButton = wizard.querySelector(".js-c-wizard-prev");
  const tabArea = wizard.querySelector(".js-wizard-tabs");
  const tabTemplate = wizard.querySelector(".js-wizard-tab");
  const wizardTitle = wizard.querySelector(".js-wizard-title");
  const wizardLinkCopy = wizard.querySelector(".js-wizard-link-copy");
  const wizardHelpText = wizard.querySelector(".js-wizard-help-text");
  const wizardMobileChange = wizard.querySelector(".js-wiz-change-btn");
  const wizardHelpToggler = wizard.querySelector(".js-wizard-toggle-help");
  const wizardCollection = document.querySelector(".js-wizard-collection");
  const multiSelectArea = wizard.querySelector(".js-wizard-multiselect-area");
  wizard.classList.remove("loading");
  const imageSingleSelectArea = wizard.querySelector(
    ".js-wizard-imagesingleselect-area"
  );
  const imageSingleSelectTemplate = wizard.querySelector(
    ".js-wizard-imagesingleselect"
  );
  const multiSelectTemplate = multiSelectArea && multiSelectArea.querySelector(
    ".js-wizard-multiselect"
  );

  // Wizard data (refreshed by render() on every fetch)
  let rbWizCollectionTags = window.rbWizCollectionTags || { tags: [] };
  let rbWizCollectionTagsApplied = window.rbWizCollectionTagsApplied || { tags: [] };
  let rbWizConfig = window.rbWizConfig || null;
  let rbWizTagImages = window.rbWizTagImages || null;

  // Holds the URL the next-button should navigate to once clicked
  let pendingNextUrl = null;

  if (wizardHelpToggler) {
    wizardHelpToggler.addEventListener("click", function (e) {
      e.preventDefault();
      wizard.classList.toggle("c-wizard--help-open");
    });
  }

  if (wizardLinkCopy) {
    wizardLinkCopy.addEventListener("click", function (e) {
      e.preventDefault();
      var dummy = document.createElement("input"),
        text = window.location.href;
      document.body.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
      wizard.classList.add("c-wizard--url-copied");
    });
  }

  if (wizardMobileChange) {
    wizardMobileChange.addEventListener("click", function (e) {
      e.preventDefault();
      if (wizard.classList.contains("c-wizard--change-open")) {
        wizard.classList.remove("c-wizard--change-open");
        this.innerText = this.dataset.closedText;
      } else {
        wizard.classList.add("c-wizard--change-open");
        this.innerText = this.dataset.openedText;
      }
    });
  }

  if (wizardPrevButton) {
    wizardPrevButton.addEventListener("click", function (e) {
      e && e.preventDefault && e.preventDefault();
      const target = rbWizGetTabLink(rbWizGetCurrentStep() - 1);
      fetchWizard({
        url: target,
        callback: () => {
          history.pushState(null, null, target);
        }
      });
    });
  }

  rbWizUpdatePrev = function (currentStepIndex) {
    if (currentStepIndex > 0) {
      // add enable prev button class
      wizard.classList.add("c-wizard--prev-rdy");
    } else {
      wizard.classList.remove("c-wizard--prev-rdy");
    }
  };

  rbWizGetCurrentStep = function () {
    const lastTag = rbWizCollectionTagsApplied.tags.reduce((a, b) => {
      const index = rbWizConfig.steps.findIndex(({ tagPrefix }) =>
        tagPrefix?.find((tag) => b?.tagName.includes(tag))
      );
      return a < index ? index : a;
    }, -1);
    const hasDia = window.location.pathname.slice(-1) === "*";
    let currentStep = lastTag + (hasDia ? 0 : 1);
    hasDia &&
      history.pushState(
        null,
        null,
        window.location.pathname.slice(0, window.location.pathname.length - 1)
      );

    if (
      rbWizConfig.steps.length - 1 <= currentStep ||
      rbWizConfig.showProducts
    ) {
      wizardCollection && wizardCollection.classList.remove("hidden");

      if (rbWizConfig.steps.length - 1 <= currentStep) {
        wizard.classList.add("c-wizard--result");
      }

      // Adding url parameters based on applied tagname
      // Solution is a cornercase solution, so done static and not via metafield
      // c_produktions_typ-verschweisst -> add &v=2
      rbWizCollectionTagsApplied.tags.forEach((appliedTag) => {
        if (appliedTag.tagName === "c_produktions_typ:Verschweißt") {
          const productLinks = document.querySelectorAll(
            ".js-collection-product-variant a"
          );
          productLinks.forEach((a) => {
            let href = a.getAttribute("href");
            if (href.includes("?")) {
              a.setAttribute("href", href + "&v=2");
            } else {
              a.setAttribute("href", href + "?v=2");
            }
          });
        }
      });
    } else {
      wizard.classList.remove("c-wizard--result");
      wizardCollection && wizardCollection.classList.add("hidden");
      //clean change open class
      wizard.classList.remove("c-wizard--change-open");
    }
    // console.log("rbWizGetCurrentStep() => " + currentStep);
    return currentStep;
  };

  rbWizUpdateTitle = function (currentStepIndex) {
    const isResult =
      rbWizConfig &&
      (rbWizConfig.steps.length - 1 <= currentStepIndex || rbWizConfig.showProducts);
    if (isResult) {
      const catTitle = wizard.querySelector(".js-wizard-cat-title");
      wizardTitle.textContent = catTitle ? catTitle.textContent.trim() : "";
      return;
    }
    const step = rbWizConfig.steps[currentStepIndex];
    wizardTitle.textContent = step && step.title ? step.title : "";
  };

  rbWizUpdateHelp = function (currentStepIndex) {
    const step = rbWizConfig.steps[currentStepIndex];
    if (!step || step.help === undefined || step.help === "") {
      wizard.classList.add("c-wizard--help-empty");
    } else {
      // hide (might have been opened previously)
      wizard.classList.remove("c-wizard--help-open");
      wizard.classList.remove("c-wizard--help-empty");
      // insert content
      wizardHelpText.innerHTML = step.help;
    }
  };

  rbWizGetTabLink = function (clickedTabIndex) {
    url = window.location.pathname;
    rbWizConfig.steps.forEach((step, stepIndex) => {
      if (clickedTabIndex <= stepIndex) {
        // console.log("---------------");
        // console.log("clickedTabIndex (clicked tab): " + clickedTabIndex);
        // console.log("step.tagPrefix: " + step.tagPrefix);
        rbWizCollectionTagsApplied.tags.forEach((appliedTag) => {
          if (
            step?.tagPrefix?.find((tag) => appliedTag.tagName.includes(tag))
          ) {
            url = url.replace(appliedTag.tagHandle, "");
            url = url.replace(/\+\+/gm, "+");
          }
        });
      }
    });

    url = url
      .replace("/+", "/")
      .replace("++", "+")
      .replace(/\+\s*$/, "");
    // console.log("rbWizGetTabLink() => url:" + url);
    return url;
  };

  const rbWizGetTabValues = function (currentStepIndex) {
    let tagValues = [];
    rbWizCollectionTagsApplied.tags.forEach((appliedTag) => {
      const selectedTag = rbWizConfig.steps[currentStepIndex].tagPrefix.find(
        (tag) => appliedTag.tagName.startsWith(tag)
      );
      const suffix = rbWizConfig.steps[currentStepIndex].suffix;
      if (selectedTag) {
        let appliedTagNoPrefix = appliedTag.tagName.replace(selectedTag, "");
        tagValues.push(appliedTagNoPrefix + (suffix ? suffix : ""));
        // console.log(
        //   "rbWizCreateTabs() => Prefix '" +
        //     selectedTag +
        //     "' of step " +
        //     currentStepIndex +
        //     " was found in applied tag '" +
        //     appliedTag.tagName +
        //     "'."
        // );
      }
    });
    return tagValues;
  };

  rbWizCreateTabs = function (currentStepIndex) {
    rbWizConfig.steps.forEach((step, stepIndex) => {
      // render all but last entry
      if (rbWizConfig.steps.length - 1 > stepIndex) {
        // clone
        let tabButton = tabTemplate.cloneNode(true);
        // unhide
        tabButton.classList.remove("hidden");
        // set category and number
        tabButton.querySelector(".js-wizard-tab-category").textContent =
          stepIndex + 1 + ". " + step.category;
        // set class
        if (currentStepIndex === stepIndex) {
          tabButton.classList.add("c-wizard__tab--active");
        } else if (currentStepIndex > stepIndex) {
          tabButton.classList.add("c-wizard__tab--done");
          // get selected values
          let tagValues = rbWizGetTabValues(stepIndex);
          // insert values
          if (tagValues.length > 0) {
            let valueArea = tabButton.querySelector(".js-wizard-tab-selection");
            // clear placeholder text
            valueArea.textContent = "";
            // add values
            tagValues.forEach((tagValue) => {
              valueArea.textContent += " " + tagValue;
            });
          }
          // link tab
          tabButton.addEventListener("click", function () {
            // window.location.href = rbWizGetTabLink(stepIndex);
            const url = rbWizGetTabLink(stepIndex);
            fetchWizard({
              url,
              callback: () => {
                history.pushState(null, null, url);
              }
            });
          });
        }
        // insert element to dom, delete template
        tabArea.appendChild(tabButton);
      }
      tabTemplate.remove();
    });
  };

  const getKeyboardInput = function (e) {
    if (e.keyCode === 13 && wizard.classList.contains("c-wizard--next-rdy")) {
      document.removeEventListener("keyup", getKeyboardInput);
      wizardNextButton.dispatchEvent(new Event("click", { bubbles: true }));
    }
  };

  const rbWizBuildNextUrl = function (initialCall) {
    let url = window.location.pathname;
    if ((url.match(/\//g) || []).length < 3) {
      url += "/";
    }
    const inputs = wizardBody.querySelectorAll(
      ".js-wizard-radio-input:checked"
    );
    inputs.forEach((input) => {
      url += "+" + input.value;
    });
    let checkboxValues;

    if (rbWizConfig.steps[rbWizCurrentStep].select === "text") {
      const radioValue = document.querySelector(
        "[name='group_name_2']:checked"
      )?.value;
      const inputValue = parseInt(
        document.querySelector(".js-wizard-text-input").value || 0
      );
      const availableValues = rbWizCollectionTags.tags
        .filter(({ tagHandle }) => radioValue && tagHandle.startsWith(radioValue))
        .map(({ tagHandle }) => parseInt(tagHandle.split(radioValue)[1]))
        .sort((a, b) => (a < b ? 1 : -1));
      if (
        availableValues.length &&
        wizard.querySelector(".js-wizard-text-input-area")
      ) {
        wizard
          .querySelector(".js-wizard-text-input-area")
          .classList.remove("hidden");
        document.addEventListener("keyup", getKeyboardInput);
      }
      const selectedValue = availableValues.filter((nr) => nr <= inputValue)[0];
      availableValues.slice(-1)[0] &&
        document
          .querySelector(".js-wizard-text-input")
          .setAttribute(
            "placeholder",
            `Bitte eine Zahl (mind. ${availableValues.slice(-1)[0]}) angeben`
          );

      if (inputValue >= availableValues.slice(-1)[0] && selectedValue) {
        url += "+" + radioValue;
        url += selectedValue;
        document
          .querySelector(".js-wizard-text-input-error")
          .classList.add("hidden");
      } else if (inputValue != "") {
        document
          .querySelector(".js-wizard-text-input-error")
          .classList.remove("hidden");
        document.querySelector(
          ".js-wizard-text-input-error-number"
        ).textContent = availableValues.slice(-1)[0];
      }
    } else if (rbWizConfig.steps[rbWizCurrentStep].select === "pill") {
      checkboxValues = Array.from(
        multiSelectArea.querySelectorAll("input:checked")
      ).map(({ value }) => value);
      url += (checkboxValues.length > 0 ? "+" : "") + checkboxValues.join("+");
      if (checkboxValues.length && !initialCall) {
        url = url.replace("/+", "/");
        const finalUrl = url + "*";
        return fetchWizard({
          url: url,
          callback: () => {
            history.pushState(null, null, finalUrl);
          }
        });
      } else if (!checkboxValues.length && !initialCall) {
        return fetchWizard({
          url: url.replace("/+", "/"),
          callback: () => {
            history.pushState(null, null, url.replace("/+", "/"));
          }
        });
      }
    }

    url = url.replace("/+", "/");

    if (
      url !== window.location.pathname ||
      (checkboxValues?.length &&
        rbWizConfig.steps[rbWizCurrentStep].select === "pill")
    ) {
      pendingNextUrl = url;
      wizard.classList.add("c-wizard--next-rdy");
      wizardNextButton.onclick = function (e) {
        e && e.preventDefault && e.preventDefault();
        if (rendering || !pendingNextUrl) return;
        const target = pendingNextUrl;
        fetchWizard({
          url: target,
          callback: () => {
            history.pushState(null, null, target);
          }
        });
      };
    } else {
      pendingNextUrl = null;
      wizardNextButton.onclick = null;
      wizard.classList.remove("c-wizard--next-rdy");
    }
  };

  function htmlDecode(input) {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
  }

  rbWizCreateTagLinks = function (currentStepIndex) {
    let tagLinks = [];
    const step = rbWizConfig.steps[currentStepIndex];
    if (!step || !step.tagPrefix) {
      return;
    }
    let tagPrefix = step.tagPrefix;
    let tagSuffix = step.suffix ? step.suffix : "";
    rbWizCollectionTags.tags
      .filter((d) => tagPrefix.find((tag) => d.tagName.startsWith(tag)))
      .forEach((tag) => {
        tagLinks.push(tag.tagHandle);
        // prepare name
        let tagNoPrefix = tag.tagName.replace(tagPrefix, "");
        // clone template
        let tagLinkClone = imageSingleSelectTemplate.cloneNode(true);
        // unhide
        tagLinkClone.classList.remove("hidden");
        // insert visible name
        tagLinkClone.querySelector(".js-wizard-radio-text").textContent =
          tagNoPrefix + tagSuffix;
        // reorder numeric value tag names correctly
        let numericValue = parseInt(tagNoPrefix);
        if (Number.isInteger(numericValue)) {
          tagLinkClone.style.order = numericValue;
        }
        // update name, id, value of input
        let tagLinkCloneRadio = tagLinkClone.querySelector(
          ".js-wizard-radio-input"
        );
        tagLinkCloneRadio.setAttribute("id", tag.tagHandle);
        tagLinkCloneRadio.setAttribute("name", tagPrefix);
        tagLinkCloneRadio.setAttribute("value", tag.tagHandle);
        // put "no präferenz" at first place and check by default
        if (tagNoPrefix === "keine Präferenz") {
          tagLinkClone.style.order = "-1";
          tagLinkCloneRadio.checked = true;
        }
        // update for attribute of label
        let tagLinkCloneLabel = tagLinkClone.querySelector(
          ".js-wizard-radio-label"
        );
        tagLinkCloneLabel.setAttribute("for", tag.tagHandle);
        // watch for changes
        tagLinkCloneRadio.addEventListener("change", (event) => {
          rbWizBuildNextUrl();
        });
        // insert element to dom, delete template
        imageSingleSelectArea.appendChild(tagLinkClone);
        imageSingleSelectTemplate.remove();
        // insert image
        if (rbWizTagImages && rbWizTagImages.tagImages) {
          rbWizTagImages.tagImages.forEach((configTagImage) => {
            if (
              tag.tagName === configTagImage.tag ||
              tag.tagName.startsWith(configTagImage.tag)
            ) {
              const tagLinkCloneImage = tagLinkCloneLabel.querySelector(
                ".js-wizard-radio-image"
              );
              if (tagLinkCloneImage) {
                tagLinkCloneImage.innerHTML = configTagImage.html || "";
              }
            }
          });
        }

        let tagMultiLinkClone = multiSelectTemplate.cloneNode(true);
        tagMultiLinkClone.classList.remove("hidden");
        // insert visible name
        tagMultiLinkClone.querySelector(
          ".js-wizard-checkbox-text"
        ).textContent = tagNoPrefix;
        let tagLinkCloneMulti = tagMultiLinkClone.querySelector(
          ".c-wizard__checkbox-input"
        );
        tagLinkCloneMulti.setAttribute("id", "p" + tag.tagHandle);
        tagLinkCloneMulti.setAttribute("name", tagPrefix);
        tagLinkCloneMulti.setAttribute("value", tag.tagHandle);
        if (window.location.pathname.includes(tag.tagHandle)) {
          tagLinkCloneMulti.checked = true;
          history.pushState(
            null,
            null,
            window.location.pathname.replace("+" + tag.tagHandle, "")
          );
        }
        tagMultiLinkClone
          .querySelector(".js-wizard-checkbox-label")
          .setAttribute("for", "p" + tag.tagHandle);
        tagLinkCloneMulti.addEventListener("change", (event) => {
          rbWizBuildNextUrl();
        });
        multiSelectArea.appendChild(tagMultiLinkClone);
        multiSelectTemplate.remove();
        document
          .querySelectorAll(".c-wizard__radio-simple-input")
          .forEach((input) =>
            input.addEventListener("change", (event) => {
              rbWizBuildNextUrl();
            })
          );
        document
          .querySelector(".js-wizard-text-input")
          .addEventListener("input", (event) => {
            rbWizBuildNextUrl();
          });
      });

    if (tagLinks.length > 0) {
      // unhide area
      if (rbWizConfig.steps[currentStepIndex].select === "text") {
        wizard
          .querySelector(".c-wizard__radio--small")
          .classList.remove("hidden");
      } else if (rbWizConfig.steps[currentStepIndex].select === "pill") {
        const pill = wizard.querySelector(".c-wizard__checkbox");
        pill.classList.remove("hidden");
      } else {
        imageSingleSelectArea.classList.remove("hidden");
      }
      rbWizBuildNextUrl(true);
    }

    // js-wizard-imagesingleselect
    // console.log("tagLinks array:");
    // console.log(tagLinks);
    // console.log(rbWizConfig.steps[currentStepIndex].select);
  };
  const render = (sectionHtml) => {
    if (!sectionHtml) return;
    const doc = new DOMParser().parseFromString(sectionHtml, "text/html");

    // Replace wizard inner content with the freshly-rendered version
    const newWizard = doc.querySelector(".js-wizard");
    if (newWizard) {
      wizard.innerHTML = newWizard.innerHTML;
    }

    // Update the products area with the new (tag-filtered) products
    if (wizardCollection) {
      const newProducts = doc.querySelector(".js-wizard-collection");
      if (newProducts) {
        wizardCollection.innerHTML = newProducts.innerHTML;
      }
    }

    // Refresh the data globals from the new JSON data block
    const dataEl = doc.querySelector(".js-wizard-data");
    if (dataEl) {
      try {
        const data = JSON.parse(dataEl.textContent);
        window.rbWizCollectionTags = { tags: data.tags || [] };
        window.rbWizCollectionTagsApplied = { tags: data.appliedTags || [] };
        window.rbWizConfig = data.config || null;
        window.rbWizTagImages = data.tagImages || null;
      } catch (err) {
        console.error("Wizard: failed to parse refreshed data JSON", err);
      }
    }
  };

  const fetchWizard = ({ url, callback } = {}) => {
    if (!url) url = window.location.pathname;
    rendering = true;
    wizard.classList.add("loading");
    return fetch(url + "?sections=wizard")
      .then((response) => response.json())
      .then((sections) => {
        const data = sections && sections.wizard ? sections.wizard : "";
        if (callback) callback(data);
        render(data);
        rendering = false;
        wizard.classList.remove("loading");
        // Re-run the initializer against the freshly-rendered DOM
        init();
      })
      .catch((err) => {
        console.error("Wizard: fetch failed", err);
        rendering = false;
        wizard.classList.remove("loading");
      });
  };

  // run
  let rendering = false;
  let rbWizCurrentStep;
  if (rbWizConfig !== null) {
    // get current step
    rbWizCurrentStep = rbWizGetCurrentStep();
    // update wizard title
    rbWizUpdateTitle(rbWizCurrentStep);
    // update help
    rbWizUpdateHelp(rbWizCurrentStep);
    // create tabs
    rbWizCreateTabs(rbWizCurrentStep);
    // create tag links
    rbWizCreateTagLinks(rbWizCurrentStep);
    // update prev button state
    rbWizUpdatePrev(rbWizCurrentStep);
    wizard.classList.remove("loading");
  } else {
    console.log("Wizard config missing.");
    wizard.classList.remove("loading");
  }
})();


  } catch(e) { console.error(e); }
})();
})();
